import React from 'react'
import MessageUI from '../../widgets/output/MessageUI'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import ViewOrUpdateSF from '../../widgets/layout/ViewOrUpdateSF'
import LRTableBodyUI from '../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../widgets/layout/LRTableRowUI'
import LRTableRowLinkUI from '../../widgets/layout/LRTableRowLinkUI'
//
import GenericErrorUI from '../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import AccountNameViewUI from '../../components/accountSettings/accountName/AccountNameViewUI'
import AccountNameUpdateSF from '../../components/accountSettings/accountName/AccountNameUpdateSF'
import CreditCardSnippetUI from '../../components/accountSettings/payment/CreditCardSnippetUI'
import SubscriptionSnippetUI from '../../components/accountSettings/subscription/SubscriptionSnippetUI'
import PrivatePageSF from '../../templates/PrivatePageSF'
import './AccountSettingsPage.css'

const AccSettingsPrjPageUI = ({context, subscription, accountName, paymentMethodList, messageList, errorList, onNameUpdated}) =>
  <PrivatePageSF context={context} className='pg_acc_st_prj' backLink='/settings'
    centered={(!accountName || !subscription) || (errorList && errorList.length > 0)}
    messageList={messageList} headerMessageKey='c_account_settings'
  >
    {
      (!accountName || !subscription) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      accountName && subscription &&
      <div>
        <PageTitleUI context={context} goBack={true} backLink='/settings' messageList={messageList} titleMessageKey='c_account_settings' />

        <LRTableBodyUI context={context}>
          {
            !context.permissions.includes('acc_manage') &&
            <LRTableRowUI context={context}
              left={<label><MessageUI messageList={messageList} messageKey='c_account_name' /></label>}
              right={<span>{accountName}</span>}
            />
          }

          {
            context.permissions.includes('acc_manage') &&
            <ViewOrUpdateSF context={context} messageList={messageList} labelMessageKey='c_account_name'
              rightViewUI={<AccountNameViewUI context={context} messageList={messageList} accountName={accountName} />}
              updateUI={<AccountNameUpdateSF context={context} messageList={messageList} accountName={accountName} onUpdateComplete={onNameUpdated} />}
            />
          }

          {
            !context.permissions.includes('acc_billing') &&
            <LRTableRowUI context={context}
              left={<label><MessageUI messageList={messageList} messageKey='c_subscription' /></label>}
              right={<span>{subscription.productName}</span>}
            />
          }

          {
            context.permissions.includes('acc_billing') &&
            <LRTableRowLinkUI
              context={context}
              to='/settings/account/subscription'
              left={<label><MessageUI messageList={messageList} messageKey='c_subscription' /></label>}
              right={<SubscriptionSnippetUI context={context} productName={subscription.productName} />}
            />
          }

          {
            context.permissions.includes('acc_billing') &&
            <LRTableRowLinkUI
              context={context}
              to='/settings/account/billing'
              left={<label><MessageUI messageList={messageList} messageKey='c_credit_card' /></label>}
              right={<CreditCardSnippetUI context={context} ccLast4={paymentMethodList.length > 0 && paymentMethodList[0].card.ccLast4} />}
            />
          }
        </LRTableBodyUI>
      </div>
    }
  </PrivatePageSF>

export default AccSettingsPrjPageUI
